<div class="fit-80">
  <app-header></app-header>
  <div class="border-top-none">
    <app-selected-client></app-selected-client>
  </div>
  <div>
    <form [formGroup]="Form2" (ngSubmit)="ValidateAndSaveForm2()">
      <!-- <ng-template matStepLabel>Declaration 1</ng-template> -->

      <div class="border-top-none">
        <div class="fit-80 blue-background mb-5 h-60 border-rad-bottom border-top-none">
          <div class="d-flex justify-center">
            <p class="mb-0">{{'FORM2_interim_OD0109' | translate}}</p>

            <a class="ml-3 tool-tip" data-toggle="tooltip" data-placement="bottom"
              title="{{'FORM2_interim_OD0111' | translate}}  {{'FORM2_interim_OD0112' | translate}} {{'FORM2_interim_OD0113' | translate}} ">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 172 172"
                style=" fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                  stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                  font-family="none" font-weight="none" font-size="none" text-anchor="none"
                  style="mix-blend-mode: normal">
                  <path d="M0,172v-172h172v172z" fill="#01aef0"></path>
                  <g fill="#ffffff">
                    <path
                      d="M86,0c-47.50716,0 -86,38.49284 -86,86c0,47.50716 38.49284,86 86,86c47.50716,0 86,-38.49284 86,-86c0,-47.50716 -38.49284,-86 -86,-86zM86,14.33333c39.58464,0 71.66667,32.08203 71.66667,71.66667c0,39.58464 -32.08203,71.66667 -71.66667,71.66667c-39.58463,0 -71.66667,-32.08203 -71.66667,-71.66667c0,-39.58463 32.08203,-71.66667 71.66667,-71.66667zM86,41.65625c-1.31576,0 -2.40755,-0.02799 -3.58333,0.22396c-1.17578,0.25195 -2.26758,0.89583 -3.13542,1.56771c-0.86784,0.67188 -1.51172,1.5957 -2.01562,2.6875c-0.5039,1.0918 -0.67187,2.37956 -0.67187,4.03125c0,1.6237 0.16797,2.91146 0.67188,4.03125c0.50391,1.11979 1.14778,2.01563 2.01563,2.6875c0.86784,0.67188 1.95964,1.06381 3.13542,1.34375c1.17578,0.27995 2.26758,0.44792 3.58333,0.44792c1.28776,0 2.65951,-0.16797 3.80729,-0.44792c1.14778,-0.27994 2.04362,-0.67187 2.91146,-1.34375c0.86784,-0.67187 1.51172,-1.56771 2.01563,-2.6875c0.50391,-1.0918 0.89583,-2.40755 0.89583,-4.03125c0,-1.65169 -0.39192,-2.93945 -0.89583,-4.03125c-0.5039,-1.0918 -1.14778,-2.01562 -2.01562,-2.6875c-0.86784,-0.67187 -1.76367,-1.31576 -2.91146,-1.56771c-1.14778,-0.25195 -2.51953,-0.22396 -3.80729,-0.22396zM77.26563,65.61979v64.27604h17.46875v-64.27604z">
                    </path>
                  </g>
                </g>
              </svg>
            </a>
          </div>
          <div>{{'FORM2_interim_OD0110' | translate}}</div>
        </div>
        <div class="fit-80 card-container border-top-none grey-banner" style="border-bottom: none;">{{'FORM2_interim_OD0114' | translate}}</div>
      </div>

      <div class="d-flex border-top-none">
        <div class="w-65 apply-border-right">
          <p class="col-1-content">
          </p>
        </div>

        <div class="w-35">
        
          <label class="mb-4">{{'FORM2_interim_OD0115' | translate}}</label>
          <input min="0" max="9,999,999.99" class="text-right" formControlName="MTva" type="text" 
            [(ngModel)]="dTVA" 
            (keypress)="validateDecimal($event)" 
            (paste)="clipboardPaste($event)"
            (blur)="formatOnFocusOut($event,'DTVA1')"            
            (focus)="formatOnFocusIn($event)" 
            (keyup)="checkMaxNo($event) ; validateOperator($event)">
            <!-- (keyup)="checkMaxNo($event)" (keyup)="testFormat($event)" (blur)="onBlurMethod($event)"-->
          &euro;
        </div>

        
      </div>


      <div *ngIf="isActivity1Present && (isActivity2Present || isActivity3Present || isActivity4Present || isActivity5Present)" class="border-top-none pt-5">
        <div class="fit-80 card-container grey-banner">
          <p class="mb-0">
            {{'FORM2_interim_OD0116' | translate}}</p>
        </div>
      </div>

      <div class="blue-background d-flex border-top-none">
        <div class="w-65 pl-6">{{'FORM2_interim_OD0117' | translate}}</div>
        <div class="w-35">{{'FORM2_interim_OD0118' | translate}}</div>
      </div>

      <!-- 1 -->
      <div class="d-flex border-top-none" *ngIf="isActivity1Present">
        <div class="w-65 apply-border-right">
          <p class="col-1-content">
            {{this.activity1Model.Label}}
          </p>
        </div>
        <div class="w-35"
          *ngIf="isActivity1Present && (isActivity2Present || isActivity3Present || isActivity4Present || isActivity5Present)">
          <div class="inline">
            <label class="mb-4">{{'FORM2_interim_OD0121' | translate}}</label>
            <input min="0" max="9,999,999.99" class="text-right" type="text"
             formControlName="activity1Net" [(ngModel)]="this.activity1Model.Net"
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY1MODEL.NET')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disablePercent($event) ; validateOperator($event)">
            &euro;
          </div>

          <div class="inline">
            <p class="percent mb-4">{{'FORM2_interim_OD0122' | translate}}</p>
            <input  min = "0" max="100" formControlName="activity1Percent"
              class="text-right" [(ngModel)]="this.activity1Model.Percentage" 
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY1PERCENT')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disableControl($event) ; validateOperator($event)"
              style="width: 4rem;"> %
          </div>
        </div>
      </div>

      <!-- 2 -->
      <div class="d-flex border-top-none" *ngIf="isActivity2Present">
        <div class="w-65 apply-border-right">
          <p class="col-1-content">
            {{this.activity2Model.Label}}
          </p>
        </div>

        <div class="w-35">
          <div class="inline">
            <label class="mb-4">{{'FORM2_interim_OD0121' | translate}}</label>
            <input min="0" max="9,999,999.99" class="text-right"
               formControlName="activity2Net" [(ngModel)]="this.activity2Model.Net"
               (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY2MODEL.NET')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disablePercent($event) ; validateOperator($event)">
            &euro;
          </div>

          <div class="inline">
            <p class="percent mb-4">{{'FORM2_interim_OD0122' | translate}}</p>
            <input  max="100" min ="0" formControlName="activity2Percent"
              class="text-right" [(ngModel)]="this.activity2Model.Percentage" 
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY2PERCENT')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disableControl($event) ; validateOperator($event)"
              style="width: 4rem;"> %
          </div>
        </div>
      </div>

      <!-- 3 -->
      <div class="d-flex border-top-none" *ngIf="isActivity3Present">
        <div class="w-65 apply-border-right">
          <p class="col-1-content">
            {{this.activity3Model.Label}}
          </p>
        </div>

        <div class="w-35">
          <div class="inline">
            <label class="mb-4">{{'FORM2_interim_OD0121' | translate}}</label>
            <input  min="0" max="9,999,999.99" class="text-right"
              formControlName="activity3Net" [(ngModel)]="this.activity3Model.Net"
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY3MODEL.NET')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disablePercent($event) ; validateOperator($event)">
            &euro;
          </div>

          <div class="inline">
            <p class="percent mb-4">{{'FORM2_interim_OD0122' | translate}}</p>
            <input  max="100" min = "0" formControlName="activity3Percent"
              class="text-right" [(ngModel)]="this.activity3Model.Percentage" 
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY3PERCENT')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disableControl($event) ; validateOperator($event)"
              style="width: 4rem;"> %
          </div>
        </div>
      </div>

      <!-- 4 -->
      <div class="d-flex border-top-none" *ngIf="isActivity4Present">
        <div class="w-65 apply-border-right">
          <p class="col-1-content">
            {{this.activity4Model.Label}}
          </p>
        </div>

        <div class="w-35">
          <div class="inline">
            <label class="mb-4">{{'FORM2_interim_OD0121' | translate}}</label>
            <input  min="0" max="9,999,999.99" class="text-right"
              formControlName="activity4Net" [(ngModel)]="this.activity4Model.Net"
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY4MODEL.NET')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disablePercent($event) ; validateOperator($event)">
            &euro;
          </div>

          <div class="inline">
            <p class="percent mb-4">{{'FORM2_interim_OD0122' | translate}}</p>
            <input  max="100" min = "0" formControlName="activity4Percent"
              class="text-right" [(ngModel)]="this.activity4Model.Percentage" 
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY4PERCENT')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disableControl($event) ; validateOperator($event)"
              style="width: 4rem;"> %
          </div>
        </div>
      </div>

      <!-- 5 -->
      <div class="d-flex border-top-none" *ngIf="isActivity5Present">
        <div class="w-65 apply-border-right">
          <p class="col-1-content">
            {{this.activity5Model.Label}}
          </p>
        </div>

        <div class="w-35">
          <div class="inline">
            <label class="mb-4">{{'FORM2_interim_OD0121' | translate}}</label>
            <input min="0" max="9,999,999.99" class="text-right"
              formControlName="activity5Net" [(ngModel)]="this.activity5Model.Net"
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY5MODEL.NET')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disablePercent($event) ; validateOperator($event)">
            &euro;
          </div>

          <div class="inline">
            <p class="percent mb-4">{{'FORM2_interim_OD0122' | translate}}</p>
            <input  max="100" min ="0" formControlName="activity5Percent"
              class="text-right" [(ngModel)]="this.activity5Model.Percentage" 
              (keypress)="validateDecimal($event)" 
              (paste)="clipboardPaste($event)" 
              
              (blur)="formatOnFocusOut($event,'ACTIVITY5PERCENT')"            
              (focus)="formatOnFocusIn($event)" 
              (keyup)="disableControl($event) ; validateOperator($event)"
              style="width: 4rem;"> %
          </div>
        </div>
      </div>
      <div class="align-buttons border-top-none extra-info-text">{{'FORM2_interim_OD0123' | translate}}</div>
      <div>
        <div class="blue-background remark border-top-none">{{'Declaration_affaires_OD0104' | translate}}</div>
        <div class=" border-top-none text-center" style="background-color: gainsboro;">
          <textarea type="text" class="w-88 my-4" [maxlength]="400" (keyup)="remarksEntered()" [(ngModel)]="remarks"
            formControlName="remarks" placeholder="">
          </textarea>
        </div>
      </div>
      <div class="align-buttons border-top-none py-5 px-4">
        <div>
          <app-popup [isDataEntered]=isDataEntered></app-popup>
        </div>
        <div class="error-message" *ngIf=msgErrorPercent>
          {{'ERROR_messages_OD0180' | translate}}
        </div>
        <div class="error-message" *ngIf=msgErrorNET>
          {{'ERROR_messages_OD0181' | translate}}
        </div>
        <div class="error-message" *ngIf=msgErrorFieldMissing>
          {{'ERROR_messages_OD0177' | translate}}
        </div>
        <div>
          <button class="btn-orange p-2" [disabled]="clicked">
            <svg class="mr-3" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32"
              viewBox="0 0 172 172" style=" fill:#000000;">
              <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                style="mix-blend-mode: normal">
                <path d="M0,172v-172h172v172z" fill="#e67e22"></path>
                <g fill="#ffffff">
                  <path
                    d="M51.87435,21.42301c-0.26282,0.00646 -0.5248,0.03219 -0.78385,0.07699h-9.88216c-10.82086,0 -19.70833,8.88748 -19.70833,19.70833v89.58333c0,10.82086 8.88748,19.70833 19.70833,19.70833h6.28483c0.57703,0.09479 1.16565,0.09479 1.74268,0h73.50732c0.57703,0.09479 1.16565,0.09479 1.74268,0h6.30583c10.82086,0 19.70833,-8.88748 19.70833,-19.70833v-75.25c-0.0005,-1.53552 -0.65764,-2.99752 -1.80566,-4.01725l-32.25,-28.66667c-0.9835,-0.87419 -2.25348,-1.35728 -3.56934,-1.35775h-2.7015c-0.57703,-0.09479 -1.16565,-0.09479 -1.74268,0h-55.59066c-0.31897,-0.05468 -0.64222,-0.08045 -0.96582,-0.07699zM41.20833,32.25h5.375v19.70833c0,6.86192 5.67974,12.54167 12.54167,12.54167h43c6.86192,0 12.54167,-5.67974 12.54167,-12.54167v-16.29997l25.08333,22.29785v72.83545c0,5.01031 -3.94802,8.95833 -8.95833,8.95833h-1.79167v-41.20833c0,-6.86192 -5.67974,-12.54167 -12.54167,-12.54167h-60.91667c-6.86192,0 -12.54167,5.67974 -12.54167,12.54167v41.20833h-1.79167c-5.01031,0 -8.95833,-3.94802 -8.95833,-8.95833v-89.58333c0,-5.01031 3.94802,-8.95833 8.95833,-8.95833zM57.33333,32.25h46.58333v19.70833c0,1.05724 -0.73442,1.79167 -1.79167,1.79167h-43c-1.05724,0 -1.79167,-0.73442 -1.79167,-1.79167zM55.54167,96.75h60.91667c1.05724,0 1.79167,0.73442 1.79167,1.79167v41.20833h-64.5v-41.20833c0,-1.05724 0.73442,-1.79167 1.79167,-1.79167z">
                  </path>
                </g>
              </g>
            </svg>
            {{'Declaration_affaires_OD0105' | translate}} </button>
        </div>
      </div>

    </form>
  </div>
</div>

<ng-http-loader [entryComponent]="customSpinnerComponent"></ng-http-loader>
